import React from 'react';
import NativeIdentityButton from './NativeIdentityButton';
const { nativeIdentityPlugin } = require('../utils/nativeIdentity');
import { useEffect, useState } from 'react';

const appId = (process.env.REACT_APP_KELIMO_FACEBOOK_APP_ID || '').trim();
let sdkPromise;
function loadSdk() {
  if (window.FB) return Promise.resolve(window.FB);
  if (!sdkPromise) sdkPromise = new Promise((resolve, reject) => {
    window.fbAsyncInit = () => {
      window.FB.init({ appId, cookie: false, xfbml: false, version: 'v23.0' });
      resolve(window.FB);
    };
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/tr_TR/sdk.js';
    script.async = true;
    script.onerror = () => reject(new Error('Facebook giriş aracı yüklenemedi.'));
    document.head.appendChild(script);
  }).catch(error => { sdkPromise = null; throw error; });
  return sdkPromise;
}

function WebFacebookIdentityButton({ onCredential, label }) {
  const [error, setError] = useState('');
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!appId) return;
    let active = true;
    loadSdk().then(() => { if (active) setReady(true); }).catch(cause => { if (active) setError(cause.message); });
    return () => { active = false; };
  }, []);
  const start = () => {
    setError('');
    try {
      window.FB.login(response => {
        if (response.authResponse?.accessToken) onCredential(response.authResponse.accessToken);
        else setError('Facebook girişi tamamlanmadı.');
      }, { scope: 'public_profile' });
    } catch (cause) { setError(cause.message); }
  };
  if (!appId) return null;
  return <div className="flex w-full flex-col items-center gap-2">
    <button type="button" onClick={start} disabled={!ready} className="facebook-identity-button relative flex h-10 w-full max-w-[400px] items-center justify-center rounded-full border border-slate-300 bg-white px-9 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-50">
      <img src="/icons/facebook.svg" alt="" className="absolute left-4 h-5 w-5" />{label}
    </button>
    {error && <p role="alert" className="text-xs text-red-700">{error}</p>}
  </div>;
}

export default function FacebookIdentityButton(props) {
  if (window.Capacitor?.isNativePlatform?.()) return nativeIdentityPlugin('facebook') ? <NativeIdentityButton provider="facebook" onCredential={props.onCredential} label={props.label} /> : <p className="text-xs text-slate-500">Facebook doğrulaması bu cihazda henüz etkin değil.</p>;
  return <WebFacebookIdentityButton {...props} />;
}
